import PropTypes from 'prop-types'
import React, { memo } from 'react'
import { SearchTabsCss } from './style'
import classNames from 'classnames'

const SearchTabs = memo((props) => {
  // 属性
  const { tabs, activeIndex, changeIndex } = props

  // 方法 - 事件函数
  function changetab(index) {
    if(changeIndex) changeIndex(index)
  }

  return (
    <SearchTabsCss>
      {tabs.map((item, index) => {
        return (
          <div
            className={classNames('tab', { active: index === activeIndex })}
            key={item}
            onClick={(e) => changetab(index)}
          >
            {item}
          </div>
        )
      })}
    </SearchTabsCss>
  )
})

SearchTabs.propTypes = {
  tabs: PropTypes.array,
  activeIndex: PropTypes.number,
  changeIndex: PropTypes.func
}

export default SearchTabs
